import Emitter from 'events'

let emitter = new Emitter()
export default emitter



/** WEBPACK FOOTER **
 ** ./src/core/Emitter.js
 **/